import Vue from "vue";

Vue.component("party-statistics", {
    props: ["partyId"],
    data() {
        return {
            loading: false,
            statistics: []
        };
    },
    methods: {
        getByPartyId() {
            const self = this;

            self.loading = true;
            self.$services.statistics.getByPartyId({
                partyId: self.partyId,
                language: window.currentLanguage,
            }).then((data) => {
                self.loading = false;
                self.statistics = data;
            });
        },
        getDetailUrl(id) {
            return `${eval("window.urls.statisticsDetails")}/${id}`;            
        },
    },
    mounted() {
        const self = this;
        self.getByPartyId();
    },
    template: `
		<div>
			<template v-if="loading"><loading></loading></template>
			<template v-else>
				<b-table :data="statistics" detail-key="id" v-if="statistics != null && statistics.length > 0">
					<b-table-column width="100%">
						<template v-slot="props">
                            <div v-if="props.row != null">
                                <a :href="getDetailUrl(props.row.id)">
                                    <b-tag type="is-primary">{{props.row.reportingPeriod}}</b-tag>
							        <span v-html="props.row.title"></span>
                                </a>
                            </div>                            
						</template>                        
					</b-table-column>                    
				</b-table>
                <b-message type="is-danger" v-else>
                    No statistics notification available for this Party.
                </b-message>
			</template>
		</div>
	`
});